import { Injectable } from '@angular/core';
// import { MediaFile } from '@app/models';
import { AuthService } from '../auth.service';

@Injectable({
  providedIn: 'root'
})
export class MaterialHelperService {
  selectedItem: any = {};
  interactiveMaterial: any = {};
  materialType = '';

  constructor(private _authService: AuthService) { }

  setMaterialToBeViewed(_item: any) {
    this.selectedItem = _item;
  }


  getMaterialToBeViewed() {
    return this.selectedItem;
  }


  passInteractiveMaterial(_item: any) {
    this.interactiveMaterial = _item;
  }


  retrieveInteractiveMaterial() {
    return this.interactiveMaterial;
  }


  setMaterialType(_type: any) {
    this.materialType = _type;
  }


  getMaterialType() {
    return this.materialType;
  }


  checkMaterialType(_item) {
    let isOwned;
    let materialType = 'viewed';

    const currentUser = this._authService.getCurrentlyLoggedInUser();

    if (currentUser?._id) {
      // Check if user owns this material
      const userName = `${currentUser?.first_name ?? ''}  ${currentUser?.last_name ?? ''}`.trim();

      this.selectedItem = _item;
      if (currentUser?.userType?.toLowerCase() === 'system admin') {
        materialType = 'system-admin';
      } else if (this.selectedItem.author === userName) {
        materialType = 'listing';
      } else if (isOwned) {
        materialType = 'owned';
      } else {
        materialType = 'viewed';
      }
    }

    return materialType;
  }
}